import axios from 'axios';
import { LauncherDownloadHost } from '../config/config-cdn';

export default (prodId, sessionid, arena_membership_no, arena_language, partnerKey) => {
	const launcherType = environment.region === 'global' ? '' : `_${environment.region.toUpperCase()}`,
		productId = prodId,
		base = new URL(LauncherDownloadHost[process.env.NODE_ENV]);

	base.searchParams.set('file', `NexonLauncherSetup${launcherType}.exe`);
	try {
		// Firefox private mode doesn't support window.ga.getAll function
		base.searchParams.set('client-id', window.ga.getAll()[0].get('clientId'));
		// eslint-disable-next-line
    } catch (e) {}
	if (productId) {
		base.searchParams.set('product-id', productId);
	}
	if (partnerKey) {
		base.searchParams.set('partnerkey', partnerKey);
	}

	// Post data to NXLog fr funnel tracking
	axios
		.post('https://titus-jp.livelog.nexon.com/client.all', {
			createdate: new Date().toISOString(),
			serviceid: process.env.VUE_APP_ENV === 'prod' ? '880916452' : process.env.VUE_APP_ENV === 'pre' ? '880913380' : '880912356', // different by the environment prod='880916452', pre='880913380' others='880912356;
			ipaddress: null,
			clientip: null,
			nexonsn: null,
			sessionid,
			sequenceno: 1,
			type: 'NXLog_Funnel',
			NXLog_Funnel: {
				prevfunnelstagename: null, //refer to confluence
				funnelstagename: 'download_file', //refer to confluence
				funnelinfo: 'launcher_setup', //r efer to confluence
				arena_membership_no, // passing membership number by region
				arena_language, // current locale
				arena_product_id: productId, // if its available
			},
		})
		.then(() => {})
		.catch(() => {});

	window.location = base.href;
};
